import * as LaWeá from "./lib/LaWeá";
export default LaWeá;
